// FunSetupBalanceNotifications.js
import { Component } from "react";
import { openNotification } from "../utils";
import audio from "../assets/audio/notification.mp3";
import { notification } from "antd";
import { StopFilled } from "@ant-design/icons";

export class FunSetupBalanceNotifications extends Component {
  componentDidUpdate(prevProps) {
    // เรียกฟังก์ชัน checkAndNotify เมื่อ props มีการเปลี่ยนแปลงที่เกี่ยวข้อง
    const { activeBank, statusNof, statusMute, minAmount } = this.props;

    if (
      activeBank !== prevProps.activeBank ||
      statusNof !== prevProps.statusNof ||
      statusMute !== prevProps.statusMute ||
      minAmount !== prevProps.minAmount
    ) {
      this.checkAndNotify();
    }
  }

  // ฟังก์ชันสำหรับเล่นเสียงแยกออกมา
  playNotificationSound = () => {
    // ดึงค่า statusMute จาก props
    const { statusMute } = this.props;

    // เช็คสถานะเสียง (ถ้าไม่ mute)
    if (statusMute) {
      // แก้ไขเงื่อนไขจาก `if (statusMute)` เป็น `if (!statusMute)`
      const displayAudio = new Audio(audio);
      displayAudio.play().catch((error) => {
        console.warn("Autoplay was prevented.", error);
      });
    }
  };

  // ฟังก์ชันสำหรับตรวจสอบและแจ้งเตือน
  checkAndNotify = () => {
    // ดึงค่าจาก props
    const { activeBank, statusNof, minAmount, t } = this.props;

    if (!statusNof) {
      console.log(`Notification : ปิด`);
      return;
    }

    const arrayAcc = Array.isArray(activeBank) ? activeBank : [];
    arrayAcc.forEach((account) => {
      // ตรวจสอบว่าบัญชีมี balance น้อยกว่า minAmount หรือไม่

      if (account.accountType === "withdrawal" && account.balance < minAmount) {
        const message = (
          <>
            ยอดเงินในบัญชี ({t(account.accountType)}) <br />
            <span style={{ fontWeight: "600" }}>
              {account.accountName} - {account.accountNumber}
            </span>{" "}
            <br />
            เหลือน้อยกว่า {minAmount} บาท โปรดตรวจสอบ
          </>
        );
        openNotification("warning", "แจ้งเตือนยอดเงินใกล้จะหมด", message);
        this.playNotificationSound();
      }
    });
  };

  render() {
    // คอมโพเนนต์นี้ไม่แสดงผลอะไรบนหน้าจอ
    return null;
  }
}





/**
 * ฟังก์ชันเปิดเสียงแจ้งเตือนและแสดงข้อความผ่าน Ant Design Notification
 * @param {('success'|'error'|'warning'|'info')} type - ประเภทของแจ้งเตือน
 * @param {string} title - หัวข้อของการแจ้งเตือน
 * @param {React.ReactNode} description - ข้อความหรือ UI JSX ที่ต้องการแจ้งเตือน
 */
export const NotificationSound = async (type, title, description) => {
  let iconUI = <StopFilled style={{ color: 'red' }} />;

  if (description && notification[type]) {
    notification[type]({
      message: title,
      description: description,
      duration: 20, // 0 คือไม่ปิดอัตโนมัติ จนกว่าผู้ใช้จะกดกากบาท
      icon: iconUI,
    });
    if (audio) {
      const displayAudio = new Audio(audio);
      displayAudio.play().catch((error) => {
        console.warn("Autoplay was prevented.", error);
      });
    }
  }
};